// @ts-strict-ignore
import {ALL_MATH_TYPES, PropertyType, RESERVED_PROPS_TO_DISPLAY_NAME, ResourceType} from 'common/report/constants';
import {currentProjectStore} from 'common/report/stores/project-details';
import {CustomEventPropertyFilter} from 'common/widgets/property-filter-menu/models/segfilter';
import {formatProperty} from 'common/util/format-property';
import {PropertySectionItem} from 'common/query-builder/query-block/properties-menu/item-menu-types';
import {FiltersOperator, QueryEventEntry} from 'common/query-builder/query-entry-section/types';
import {LocalizationStore} from 'common/i18n/store';

export function asPropertyItem(value: string, pType: PropertyType, rType: ResourceType = null): PropertySectionItem {
  rType = rType || ResourceType.Event;
  return {
    value,
    resourceType: rType,
    label: RESERVED_PROPS_TO_DISPLAY_NAME[value] || value,
    type: pType,
    propertyDefaultType: pType,
  };
}

export function asEventItem(
  value: string,
  label: string,
  custom: boolean,
  filters: CustomEventPropertyFilter[],
  dataGroupId: string,
): QueryEventEntry {
  return {
    aggregationOperator: ALL_MATH_TYPES.TOTAL,
    aggregationOperatorPerUser: null,
    dataGroupId,
    event: {
      custom,
      label,
      value,
    },
    filters,
    filtersOperator: FiltersOperator.And,
    property: null,
    type: ResourceType.Event,
  };
}

export function columnNamesToSelectedProperties(columns: string[], rType: ResourceType = null): PropertySectionItem[] {
  return columns.map((column: string) => asPropertyItem(column, PropertyType.String, rType));
}

export function selectedPropertiesToColumnNames(selectedProperties: PropertySectionItem[]) {
  return selectedProperties.map((item) => item.value);
}

export function formatEventProperty(
  propertyName: string,
  propertyValue: any,
  {relativeTime, i18n}: {relativeTime: boolean; i18n: LocalizationStore},
): {formattedName: string; formattedValue: string; href?: string; raw?: string} {
  const {name, renderValue} = formatProperty(propertyName, propertyValue, {
    resourceType: ResourceType.Event,
    timezone: currentProjectStore.value?.timezone,
    relativeTime,
    i18n,
  });
  const result: any = {formattedName: name.formatted, formattedValue: renderValue.renderString};
  if (`href` in renderValue) {
    result.href = renderValue.href;
  }
  if (`raw` in renderValue) {
    result.raw = renderValue.raw;
  }
  return result;
}
